package com.bikompanion.data.parking

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.withTimeout
import com.bikompanion.data.logNetwork

private external fun encodeURIComponent(uri: String): String

internal actual fun createOverpassTransport(): OverpassTransport = FetchOverpassTransport()

/**
 * `fetch` rather than Ktor, because posting the query as a plain
 * `application/x-www-form-urlencoded` body is a CORS "simple request" — no preflight, which is
 * what lets the browser talk to the Overpass mirrors directly at all. Adding any header of our
 * own (a `User-Agent`, say) would trigger a preflight the mirrors don't answer.
 */
private class FetchOverpassTransport : OverpassTransport {
    override suspend fun post(
        endpoint: String,
        query: String,
    ): String {
        // Without this the request had no time limit of any kind on web: a mirror that accepts
        // the connection and then stalls held the whole fetch open indefinitely, because a
        // cancelled coroutine abandons the promise without stopping the request behind it.
        val controller: dynamic = js("new AbortController()")
        val headers: dynamic = js("({})")
        headers["Content-Type"] = "application/x-www-form-urlencoded"
        val init: dynamic = js("({})")
        init["method"] = "POST"
        init["headers"] = headers
        init["body"] = "data=${encodeURIComponent(query)}"
        init["signal"] = controller.signal
        logNetwork("Overpass", "REQUEST: POST $endpoint")
        return try {
            withTimeout(OverpassAttemptTimeoutMillis) {
                val response = window.fetch(endpoint, init).await()
                // Checked here so a throttled mirror fails as a mirror being down, rather than
                // reaching the parser as an HTML body and failing as unreadable data.
                if (!response.ok) {
                    error("Overpass $endpoint answered ${response.status}")
                }
                val body = response.text().await()
                logNetwork("Overpass", "RESPONSE: ${response.status} $endpoint (${body.length} chars)")
                body
            }
        } catch (error: Throwable) {
            // Covers the racer cancelling a losing attempt as well as our own timeout — either
            // way the browser should stop fetching rather than finish a body nobody will read.
            controller.abort()
            throw error
        }
    }
}
